import { clearCryptoSession } from './cryptoSessionHelper';
import { clearAutoSave } from './personalInfoAutoSave';
import * as storageKeys from '../actions/storageKeys';
import { deleteCookieDomain } from './cookieManager';

// Remove access-token cookie to ensure user is logged out
// Derive parent domain from the current hostname so it works in all environments regardless of TLD
function clearAccessTokenCookie() {
  const hostParts = window.location.hostname.split('.');
  const parentDomain = hostParts.length > 1 ? `.${hostParts.slice(-2).join('.')}` : window.location.hostname;
  deleteCookieDomain(storageKeys.AUTH_TOKEN_PARAM_KEY, parentDomain);
}

// Everything a logout has to remove from the browser, as opposed to the Redux store. Shared by the
// rootReducer's USER_LOGOUT_SUCCESS reset and userLogoutBeforeLeaving, which has to clear the
// session straight away but cannot reset the store until the page is being left.
export default function clearLocalSession() {
  // Read the application id before it is removed: the auto-saved personal info is keyed by it
  clearAutoSave(sessionStorage.getItem(storageKeys.APPLICATION_ID_KEY));
  sessionStorage.removeItem(storageKeys.AUTH_TOKEN_KEY);
  sessionStorage.removeItem(storageKeys.APPLICATION_ID_KEY);
  clearCryptoSession();
  clearAccessTokenCookie();
}
